module.exports = __webpack_public_path__ + "static/media/gluonix_imagelogo.0714dbe1.svg";